import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { MapPin, Calendar, Users, ChevronRight } from "lucide-react";

export default function ChapterList() {
  const { data: chapters = [], isLoading } = useQuery({
    queryKey: ["admin-chapters"],
    queryFn: () => api.get("/admin/chapters"),
  });

  if (isLoading) return <div className="py-12 text-center"><div className="w-10 h-0.5 bg-bronze mx-auto animate-pulse" /></div>;

  return (
    <div data-testid="chapter-list-page">
      <div className="flex items-center justify-between gap-4 mb-8">
        <h1 className="font-serif text-2xl sm:text-3xl text-cream tracking-wide">Chapters</h1>
      </div>

      <div className="space-y-3">
        {chapters.map((ch) => (
          <Link
            key={ch.id}
            to={`/admin/chapters/${ch.id}`}
            className="block bg-walnut border border-lv-border p-4 sm:p-5 hover:border-bronze/40 transition-colors group"
            data-testid={`chapter-row-${ch.code}`}
          >
            <div className="flex items-center justify-between gap-3">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-3 mb-1">
                  <h3 className="text-sm text-cream font-medium tracking-wide">{ch.name}</h3>
                  <span className={`text-[9px] uppercase tracking-wider px-2 py-0.5 ${ch.status === "ACTIVE" ? "text-lv-active bg-lv-active/10" : "text-lv-inactive bg-lv-inactive/10"}`}>{ch.status}</span>
                </div>
                <div className="flex items-center gap-4 text-xs text-lv-muted">
                  {ch.city && <span className="inline-flex items-center gap-1"><MapPin size={11} /> {ch.city}{ch.country ? `, ${ch.country}` : ""}</span>}
                  {ch.founding_date && <span className="inline-flex items-center gap-1"><Calendar size={11} /> {ch.founding_date}</span>}
                  {ch.chapter_leads?.length > 0 && <span className="inline-flex items-center gap-1"><Users size={11} /> {ch.chapter_leads.length} lead{ch.chapter_leads.length !== 1 ? "s" : ""}</span>}
                </div>
                {ch.description && <p className="text-xs text-lv-muted/70 mt-1.5 line-clamp-1">{ch.description}</p>}
              </div>
              <ChevronRight size={16} className="text-lv-muted group-hover:text-bronze transition-colors shrink-0" />
            </div>
          </Link>
        ))}
        {chapters.length === 0 && <p className="text-sm text-lv-muted text-center py-8">No chapters found.</p>}
      </div>
    </div>
  );
}
